export const EMPLOYMENT_TYPE_OPTIONS = [
  { value: 'Trainee', label: 'Trainee' },
  { value: 'kurzfristig', label: 'Kurzfristig beschäftigt' },
  { value: 'Minijob', label: 'Minijob' },
  { value: 'Werkstudent', label: 'Werkstudent:in' },
  { value: 'Teilzeit', label: 'Teilzeit' },
  { value: 'Vollzeit', label: 'Vollzeit' },
] as const;

export type EmploymentTypeCode = typeof EMPLOYMENT_TYPE_OPTIONS[number]['value'];

export const GENDER_OPTIONS = [
  { value: 'w', label: 'Weiblich' },
  { value: 'm', label: 'Männlich' },
  { value: 'd', label: 'Divers' },
  { value: 'x', label: 'X / ohne Angabe' },
];

export const LOHNSTKL_OPTIONS = [
  { value: 'I', label: 'Klasse I' },
  { value: 'II', label: 'Klasse II' },
  { value: 'III', label: 'Klasse III' },
  { value: 'IV', label: 'Klasse IV' },
  { value: 'V', label: 'Klasse V' },
  { value: 'VI', label: 'Klasse VI' },
];

export const RELIGION_OPTIONS = [
  { value: 'Römisch-katholisch', label: 'Römisch-katholisch' },
  { value: 'Evangelisch', label: 'Evangelisch' },
  { value: 'Nicht Mitglied der Kirche', label: 'Nicht Mitglied der Kirche' },
  { value: 'other', label: 'Sonstige / Andere' },
];

export const HEALTH_INS_TYPE_OPTIONS = [
  { value: 'gesetzlich', label: 'Gesetzlich' },
  { value: 'privat', label: 'Privat' },
];
